import { h, Component } from 'preact';
import Store from 'store/store';
import * as jsonPointer from 'utils/jsonPointer';
import { getIcon } from 'utils/icons';
import { confirm } from 'utils/modal';
import { joinClasses } from 'utils/utils';

import Button from 'components/button/button';
import WithTooltip from 'components/tooltip/withTooltip';

import s from 'components/editor/settings/inheritIndicator.sss';

export default class InheritIndicator extends Component {
	constructor(props) {
		super(props);
		
		this.onReset = this.onReset.bind(this);
	}

	getSettingsName(type = this.props.type) {
		return type === 'locale' ? 'Locale' : 'Global';
	}

	hasDefinedValue(value = jsonPointer.get(Store.get().data, this.props.path), includeOrder = false) {
		if (this.props.forceInherits) return false;
		if (value && typeof value === 'object' && !Array.isArray(value)) {
			return Object.entries(value)
				.filter(([key]) => includeOrder || key !== 'order') // `order` alone isn't an override
				.some(([, value]) => typeof value === 'object' ? this.hasDefinedValue(value, true) : value !== undefined);
		}
		return value !== undefined;
	}

	async onReset() {
		const settingsName = this.getSettingsName().toLowerCase();
		const result = await confirm(`This will remove local overrides and reset back to default ${settingsName} settings.`, {
			title: `Reset to ${settingsName} settings?`,
			button: 'Reset',
			danger: true,
		});
		if (!result) return;

		const { onReset, path } = this.props;
		jsonPointer.removeDeep(Store.get().data, path);
		onReset?.(path);
	}

	getIconName(hasValue, type) {
		const iconName = type === 'locale' ? 'map-pin' : 'globe';
		return hasValue ? `${iconName}-cancel` : iconName;
	}

	getTooltipText(hasValue, type) {
		const { group, tooltipInherit, tooltipNotInherit } = this.props;
		const settingsName = this.getSettingsName(type);

		if (hasValue) {
			return tooltipNotInherit || `${group ? 'At least one item is not' : 'Not'} inheriting ${settingsName} Settings.\nReset to revert to ${settingsName} Settings.`;
		}

		return tooltipInherit || `Inherited from ${settingsName} Settings.\nChanges here will only affect the selected ${type === 'locale' ? 'movie' : 'locale'}.`;
	}

	render(props) {
		const { align = 'end', dark, hideReset, primary, type = 'global' } = props;
		const hasValue = this.hasDefinedValue();
		const iconName = this.getIconName(hasValue, type);
		const settingsName = this.getSettingsName(type).toLowerCase();
		const showReset = !hideReset && hasValue;

		return (
			<div class={joinClasses(s.inheritIndicator, s[`align-${align}`], props.class)}>
				<WithTooltip
					direction="top"
					align={align}
					dark={dark}
					tooltip={this.getTooltipText(hasValue, type)}
					key="inheritIndicator"
				>
					{getIcon(iconName)}
				</WithTooltip>
				{showReset && (
					<Button
						class={s.resetButton}
						icon={align !== 'end' && 'reset'}
						iconAlt={align === 'end' && 'reset'}
						primary={primary ?? !dark}
						onClick={this.onReset}
						expandOnHover
						small
						text
					>
						Reset to {settingsName}
					</Button>
				)}
			</div>
		);
	}
}
